import { Pipe, PipeTransform } from '@angular/core';
import ikPrice, { numberToConvert, priceDefaultConfiguration } from '@infomaniak/currency';

export type CURRENCY = 'CHF' | 'EUR';

export interface NumberToConvertExtended extends priceDefaultConfiguration {
  amountVAT?: number;
  amountNoVAT?: number;
  amount?: any;
  textBefore?: string;
  textAfter?: string;
  textUnder?: string;
  textPromotion?: string;
  resultDisplay?: 'html' | 'text';
}

export interface NumberToConvertForked extends priceDefaultConfiguration {
  amount: {
    amountVAT: number | string;
    amountNoVAT: number | string;
  };
  textBefore?: string;
  textAfter?: string;
  textUnder?: string;
  textPromotion?: string;
}

@Pipe({
  name: 'mycurrency',
  pure: false,
})
export class CurrencyPipe implements PipeTransform {
  currency: CURRENCY = window['CONST_CURRENCY'].label;
  currencySign = window['CONST_CURRENCY'].sign;
  taxMode = false; // false = no vat | true = vat
  ttcMois: string;

  constructor() {}

  /**
   * @param htValue: number | string | numberToConvert | NumberToConvertExtended | NumberToConvertForked
   * @param ttcValue?: number | string | numberToConvert | NumberToConvertExtended | NumberToConvertForked
   * The method is rules by global taxMode configuration. If we need to switch to tax/notax, prices will switches automatically if both value are provided.
   * You can give the configuration via numberToConvert in htValue, it'll be used automatically on ttcValue if needed.
   */
  transform(
    htValue: number | string | NumberToConvertExtended | NumberToConvertForked | numberToConvert,
    ttcValue?: number | string | NumberToConvertExtended | NumberToConvertForked | numberToConvert
  ): string {
    if (localStorage) {
      this.taxMode = localStorage.getItem('incl_vat') === 'true';
    }
    // if we have only one value, we use it.
    if (typeof ttcValue !== 'number' && !ttcValue /** we check number type to avoid 0 === false */) {
      return this.handleConvert(htValue);
    }

    if (!this.taxMode) {
      return this.handleConvert(htValue);
    } else {
      // if htValue contains the configurated object and not ttcValue, we inject it in ttcValue
      if (typeof ttcValue !== 'object' && typeof htValue === 'object') {
        ttcValue = { ...htValue, amount: +ttcValue };
      }

      return this.handleConvert(ttcValue);
    }
  }

  private handleConvert(
    value: number | string | NumberToConvertExtended | NumberToConvertForked | numberToConvert
  ): string {
    // console.warn('value to be traited:', value);
    if (typeof value !== 'string' && typeof value !== 'number' && value) {
      if ('amountVAT' in value) {
        const { amountVAT, amountNoVAT, ...rest } = value;
        value = {
          amount: this.taxMode ? amountVAT : amountNoVAT,
          ...rest,
        } as numberToConvert;
      } else if ('amount' in value && typeof value.amount === 'object') {
        const { amount, ...rest } = value;
        value = {
          ...rest,
          amount: this.taxMode ? amount?.amountVAT : amount?.amountNoVAT,
        } as numberToConvert;
      }
    }

    return ikPrice.convert(value as string | number | numberToConvert);
  }
}
